export default "__VITE_ASSET__BDQO0nL1__"